<template>
  <div style="padding:100px 8%;">
    <div class="tab-pane pt-3 active show" v-if="ready">
      <div class="insurance-editor">
        <div class="row">
          <div class="col-12">
            <h4>保障項目對應商品查詢</h4>
            <form class="form">
              <div class="panel panel-form searchArea" :class="{'section-loading': isOptionLoading}">
                <h4 class="text-green text-center">搜尋條件</h4>
                <!-- 保障分類 -->
                <div class="form-group row">
                  <label class="col-2 text-right">保障分類</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-large"
                      :class="{'is-invalid': isCategoryError}"
                      v-model="category"
                      >
                      <option value="">請選擇</option>
                      <option
                        v-for="(item, index) in options.category"
                        :key="index"
                        :value="item.coveragecategoryid"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 保障項目 -->
                <div class="form-group row" >
                  <label class="col-2 text-right">保障項目</label>
                  <div class="col-9">
                    <div style="margin: 0 5px">
                      <v-select
                        v-if="options.coverageItem.length"
                        :class="{'is-invalid': isCoverageItemError}"
                        :options="options.coverageItem"
                        :reduce="(item) => item.coveragecategoryid"
                        v-model="coverageItem"
                        label="covergename"
                        placeholder="請選擇或輸入"
                        >
                        <div slot="no-options">沒有資料可供選擇 !</div>
                      </v-select>
                      <v-select
                        v-else
                        :placeholder="category === '' ? '請先選擇保障分類':'沒有資料可供選擇 !'"
                        disabled
                        ></v-select>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="doSearch()"
                    >
                  搜尋
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12 mt-50" v-if="itemData.length" :class="{'section-loading': isTableLoading}">
            <table class="table datatable">
              <thead>
                <tr>
                  <th style="width:10%" class="text-center">序號</th>
                  <th style="width:10%" class="text-center">險種</th>
                  <th style="width:10%" class="text-center">主/附約</th>
                  <th style="width:20%" class="text-center">公司名稱</th>
                  <th style="width:40%" class="text-center">商品名稱</th>
                  <th style="width:10%" class="text-center">險別代碼</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, i) in itemData" :key="`coverage-data-${i}`">
                  <td>{{data.productNumber}}</td>
                  <td>{{data.productType}}</td>
                  <td>{{data.contractType}}</td>
                  <td>{{data.companyName}}</td>
                  <td>{{data.productName}}</td>
                  <td>{{data.planCode}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <message
        class="mt-5 d-flex justify-content-center"
        loading
        message="資料讀取中，請稍候..."
        />
    </div>
  </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import {
  queryCoverageCategoryMain,
  queryCoverageCategory,
  queryCoverage,
} from "@/service";
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoverageItemQuery",
  components: {
    Message,
  },
  mixins: [commonMixin],
  data() {
    return {
      options: {
        category: [],
        coverageItem: [],
      },
      category: "",
      coverageItem: "",
      itemData: [],
      contractType: { 1: "主約", 2: "附約" },
      productType: { 1: "傳統型", 2: "投資型", 3: "利變型", 4: "傳統型(取大)" },
      isOptionLoading: false,
      isTableLoading: false,
      isCoverageItemError: false,
      isCategoryError: false,
    };
  },
  watch: {
    category() {
      this.queryCoverageCategory();
    },
  },
  methods: {
    async init() {
      const res = await queryCoverageCategoryMain(
        this.$store.state.userInfo.id
      );
      this.options.category = res.data;
    },
    queryCoverageCategory() {
      this.coverageItem = "";
      if (!this.category) {
        this.options.coverageItem = [];
        return;
      }
      queryCoverageCategory(this.$store.state.userInfo.id, this.category).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.options.coverageItem = result.data;
          } else {
            this.options.coverageItem = [];
          }
          this.isOptionLoading = false;
        }
      );
    },
    doSearch() {
      if (this.validateForm()) {
        return;
      }
      this.isTableLoading = true;
      queryCoverage(this.$store.state.userInfo.id, this.coverageItem).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.itemData = result.data.map((item, index) => {
              return {
                companyName: item.compnm,
                contractType: this.contractType[item.contracttype],
                productNumber: index + 1,
                productName: item.name,
                planCode: item.plan_code,
                productType: this.productType[item.producttype],
              };
            });
          } else {
            this.itemData = [];
            this.$toast.info({ title: result.header.message });
          }
          this.isTableLoading = false;
        }
      );
    },
    validateForm() {
      let isError = false;
      this.isCoverageItemError = false;
      this.isCategoryError = false;
      if (!this.category) {
        isError = true;
        this.isCategoryError = true;
        this.$toast.info({ title: "[保障分類]選單必須選擇" });
      } else if (!this.coverageItem) {
        isError = true;
        this.isCoverageItemError = true;
        this.$toast.info({ title: "[保障項目]選單必須選擇" });
      }
      return isError;
    },
  },
  computed: {
    ready() {
      return !window._.isEmpty(this.options.category);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.mt-50 {
  margin-top: 50px;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
</style>
